<mat-card class="card" [ngClass]='{nopicture : !picture}' (click)="details()" (mouseenter)="view = true"
  (mouseleave)="view = false;">

  <div class="card-header">
    <!--(click)="view = !view" -->
    <mat-card-title>
      <span title="{{pid.name}}" class="cursor" (click)="details()">{{pid.name}}</span>
    </mat-card-title>

    <div class="type">
      <img alt="{{translate.instant('PID.TYPE.' + pid.type)}}" class="logo" src="{{type2imgfn(pid.type)}}"
        style="height:22px;top:65px;position:absolute" />
    </div>

    <div *ngIf="picture" mat-card-image class="overlay-container">
      <img [src]="pid.img.url" (error)="fallbackImg($event)" class="card-image" />
    </div>

    <p class="pid-completion">
      <span class="percentage"
        *ngIf="!pid.parentPID && pid && pid.children && pid.children.length">{{translate.instant('PID_CARD.SUB_PID_COUNT')}}:
        {{pid && pid.children ? pid.children.length : 0}}</span><br />
      <span class="percentage">{{translate.instant('PID_CARD.PID')}} <span *ngIf="pid.fileTotal">{{pid.fileCompleted}} /
          {{pid.fileTotal}}</span></span>
      <span *ngIf="pid.late"><img alt="late" class="status-icon first"
          src="../../assets/Nestas_status_late.png" /></span>
      <!--<i class="material-icons pid-card-icon">watch_later</i>-->
      <span *ngIf="pid.warning"><img alt="warning" class="status-icon" ngClass='{first: !pid.late}'
          src="../../assets/Nestas_status_warning.png" /></span>
      <!--<i class="material-icons pid-card-icon ic-yellow">error</i>-->
      <mat-progress-bar mode="determinate" [value]="pid.percentage" [class.progress-bar-attention]="pid.percentage < 40"
        [class.progress-bar-warning]="pid.percentage >= 40 && pid.percentage < 70"></mat-progress-bar>
    </p>


    <mat-card-subtitle *ngIf="pid.shortDescription" title="{{pid.shortDescription}}">{{pid.shortDescription}}
    </mat-card-subtitle>

    <mat-card-content>

      <div *ngIf="pid.owner">
        {{translate.instant('DATA.OWNER')}}:
        <span (mouseenter)="details.classList.add('show')" (mouseleave)="details.classList.remove('show')"
          class="highlight-info">
          {{(pid.owner.firstname || pid.owner.lastname) ? pid.owner.firstname + ' ' + pid.owner.lastname :
          pid.owner.company}}
          <i class="material-icons">arrow_drop_down</i>
        </span><br />
        <div #details class="details">
          <a href="mailto:{{pid.owner.email}}" class="cursor">{{pid.owner.email}}</a><br />
          <a href="tel:{{pid.owner.phone}}" class="cursor">{{pid.owner.phone}}</a><br />
        </div>
      </div>

      <div *ngIf="!pid.owner && !user.me().company">
        {{translate.instant('DATA.OWNER')}}:
        <span class="highlight-info">{{translate.instant('PID_CARD.YOU_ARE_THE_OWNER')}}
          {{pid.PIDOwner.email}}</span><br />
      </div>

      <div *ngIf="!pid.owner && user.me().company">
        {{translate.instant('DATA.CREATED')}}:
        <span class="highlight-info">{{pid.PIDOwner.email}}</span><br />
      </div>

      <p class="address">
        {{pid.address.address}}<br />
        {{pid.address.zip}} {{pid.address.city}}<span *ngIf="pid.address.country">, </span>{{pid.address.country}}<br />
      </p>

      <div class="transferred"
        *ngIf="!pid.copy && pid.transferTo && !pid.transferTo.pending && !pid.template && !(pid.sharedWith && pid.sharedWith.length) && (!pid.transferTo || (pid.transferTo && !pid.transferTo.completedAt))">
        {{translate.instant('PID_CARD.NOT_SHARED_TRANSFERRED')}}
      </div>

      <div class="transferred"
        *ngIf="!pid.template && pid.transferTo && pid.transferTo.pending && pid.transferTo.transferType != 'shared' && !sharedWithMe(pid)">
        {{translate.instant('PID_CARD.TRANSFER_PENDING')}}
        <span *ngIf="pid.transferTo.details.length">{{transferInfo(pid)}}</span>
      </div>

      <div class="transferred"
        *ngIf="!pid.copy && !pid.template && pid.transferTo && pid.transferTo.pending && pid.transferTo.transferType == 'shared' && !sharedWithMe(pid) && !pid.sharedWith.length">
        {{translate.instant('PID_CARD.SHARED_PENDING')}}
        <span *ngIf="pid.transferTo.details.length">{{transferInfo(pid)}}</span>
      </div>

      <div *ngIf="pid.copy && !pid.template && pid.transferTo && pid.transferTo.pending == false && pid.transferTo.transferType != 'shared' && pid.transferTo?.details?.length"
        class="transferred">
        {{translate.instant('PID_CARD.TRANSFERRED_TO')}}
        <span *ngIf="pid.transferTo.details.length">{{transferInfo(pid)}}</span> <span
          *ngIf="!pid.transferTo.pending && pid.transferTo?.PID != pid">{{translate.instant('PID_CARD.AT_DATE')}}
          {{pid.transferTo.completedAt | date: 'dd/MM/yyyy'}}</span>
      </div>

      <div *ngIf="!pid.copy && !pid.template && pid.sharedWith && pid.sharedWith.length && sharedWithMe(pid)"
        class="transferred">{{translate.instant('DATA.SHARED_WITH_ME')}}
      </div>

      <div *ngIf="!pid.copy && !pid.template && pid.sharedWith && pid.sharedWith.length && !sharedWithMe(pid)"
        class="transferred">{{translate.instant('PID_CARD.SHARED')}}
        {{sharedInfo(pid)}}
      </div>

      <div *ngIf="pid.copy && pid.template" class="transferred">{{translate.instant('PID_CARD.TEMPLATE')}}</div>



    </mat-card-content>
  </div>
  <div *ngIf="editable" class="actions" [ngClass]="{'border' : true}" (click)="details()">

    <!--<a (click)="details()" title="{{translate.instant('BUTTON.ACTION.VIEW2')}}"><i class="material-icons overlay-ic">remove_red_eye</i></a>-->
    <a *ngIf="userIsAllowed() && (pid.template || 1)" [ngClass]="{'border' : picture && !pid.copy}" class="img"
      (click)="modal.newPID = true; $event.stopPropagation();" title="{{translate.instant('BUTTON.ACTION.COPY')}}"><img
        alt="copy" src="../../assets/Nestas_toolbox_dupliceren.png" /></a>


    <a class="img" [ngClass]="{'border' : !sharedWithMe(pid)}" *ngIf="picture && userIsAllowed() && !pid.copy"
      (click)="modal.editPID = true; $event.stopPropagation();" title="{{translate.instant('BUTTON.ACTION.EDIT')}}"><img
        alt="edit" src="../../assets/Nestas_toolbox_bewerken.png" /></a>

    <!--&& allowTransfer()-->
    <a class="img" *ngIf="userIsAllowed() && allowTransfer() && !sharedWithMe(pid)"
      (click)="modal.pid = pid; modal.transferPID = true; $event.stopPropagation();"
      title="{{translate.instant('BUTTON.ACTION.TRANSFER')}}">
      <img alt="transfer" src="../../assets/Nestas_toolbox_delen_narrow.png" />
    </a>

    <div *ngIf="picture" style="margin-top:20px;">
      <a (click)="details(row)"
        style="margin-left:2px;border: 1px solid #d1d4d7;border-radius: 10px;text-transform: uppercase;">{{translate.instant('DATA.DOCUMENTEN')}}
      </a>
    </div>

  </div>
</mat-card>


<!-- Edit PID -->
<fsmodal *ngIf="editable" [show]="modal.editPID" [closable]=true (closed)="modal.editPID = false;"
  class="edit-pid-component">

  <div class="modal-body-content">
    <div>
      <nestas-toolbar [modal]="modal"></nestas-toolbar>
    </div>
    <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="pid"></nestas-pidinfo>

    <div class="wrap">
      <new-pid #modalEditPID *ngIf="modal.editPID" [newPID]="pid" [parentPID]="pid.parentPID" [pids]="[]"
        (cancelled)="modal.editPID = false;"></new-pid>
      <div style="margin-top:40px; margin-bottom:120px;">
        <button mat-stroked-button (click)="modal.editPID = false">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
        <button mat-raised-button (click)="modalEditPID.addPID()" color="primary">
          {{translate.instant('BUTTON.ACTION.SAVE')}}
        </button>
      </div>
    </div>
  </div>
</fsmodal>



<!-- Copy PID -->
<fsmodal [show]="modal.newPID" [closable]=true (closed)="modal.newPID = false;">
  <div class="modal-body-content">
    <div>
      <nestas-toolbar [modal]="modal"></nestas-toolbar>
    </div>

    <div class="wrap">
      <nestas-pidinfo *ngIf="pid && steps" [steps]="steps" [pid]="pid"></nestas-pidinfo>

      <new-pid #modalCopyPID *ngIf="modal.newPID" [copyOf]="pid" [parentPID]="pid.parentPID" [pids]="pids"
        (done)="reload()" (cancelled)="modal.newPID = false;"></new-pid>

      <div style="margin-top:40px; margin-bottom:120px;">
        <button mat-stroked-button (click)="modal.newPID = false">{{translate.instant('BUTTON.ACTION.CANCEL')}}</button>
        <button mat-raised-button (click)="modalCopyPID.addPID();" color="primary">
          {{translate.instant('BUTTON.ACTION.SAVE')}}
        </button>
      </div>
    </div>
  </div>
</fsmodal>

<!-- transfer PID -->
<pid-transfer-modal *ngIf="editable" [show]="modal.transferPID" [pids]="pids" [steps]="steps" [modal]="modal"
  [doUpdateFilter]="reloadHome">
</pid-transfer-modal>